export const links = [
  {
    name: 'openai',
    url: 'https://openai.com/blog/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'kdnuggets',
    url: 'https://www.kdnuggets.com/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'facebook ai blog',
    url: 'https://ai.facebook.com/blog',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'decrypt',
    url: 'https://decrypt.co/',
    category: 'general',
    frequency: 7,
  },
  {
    name: 'fiftytwo',
    url: 'https://fiftytwo.in/',
    category: 'general',
    frequency: 7,
  },
  {
    name: 'pragati',
    url: 'https://www.thinkpragati.com/',
    category: 'general',
    frequency: 7,
  },
  {
    name: 'facebook blog',
    url: 'https://about.fb.com/news/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'google ai blog',
    url: 'https://ai.googleblog.com/',
    category: 'ML/DL',
    frequency: 1,
  },
  {
    name: 'deepmind',
    url: 'https://deepmind.com/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'google blog',
    url: 'https://www.blog.google/',
    category: 'general_tech',
    frequency: 2,
  },
  {
    name: 'movie of the night',
    url: 'https://www.movieofthenight.com/',
    category: 'movie recommendation',
    frequency: 7,
  },
  {
    name: 'a junior vc',
    url: 'https://ajuniorvc.com/',
    category: 'biz',
    frequency: 7,
  },
  {
    name: 'fortune',
    url: 'https://fortune.com/',
    category: 'biz',
    frequency: 7,
  },
  {
    name: 'gizmodo',
    url: 'https://gizmodo.com/',
    category: 'general',
    frequency: 3,
  },
  {
    name: 'inc',
    url: 'https://www.inc.com/',
    category: 'biz',
    frequency: 4,
  },
  {
    name: 'skynet',
    url: 'https://www.skynettoday.com/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'nature',
    url: 'https://www.nature.com/',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'producthunt',
    url: 'https://www.producthunt.com/',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'app.getpocket',
    url: 'https://app.getpocket.com/',
    category: 'saved articles',
    frequency: 1,
  },
  {
    name: 'the morning context',
    url: 'https://themorningcontext.com/',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'financial times tech',
    url: 'https://www.ft.com/technology',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'stratecherry',
    url: 'https://stratechery.com',
    category: 'general',
    frequency: 2,
  },

  {
    name: 'kaggle',
    url: 'https://www.kaggle.com/discussion',
    category: 'ML/DL',
    frequency: 1,
  },
  {
    name: 'kaggle-blog',
    url: 'https://medium.com/kaggle-blog',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'pytorch forums',
    url: 'https://discuss.pytorch.org/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'huggingface forums',
    url: 'https://discuss.huggingface.co/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'huggingface blog',
    url: 'https://huggingface.co/blog',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'toi',
    url: 'https://epapers.timesgroup.com/',
    category: 'newspapers',
    frequency: 1,
  },
  {
    name: 'vijayavani',
    url: 'https://epapervijayavani.in',
    category: 'newspapers',
    frequency: 1,
  },
  {
    name: 'kannada prabha',
    url: 'https://kpepaper.asianetnews.com',
    category: 'newspapers',
    frequency: 1,
  },
  {
    name: 'vishwavani',
    url: 'https://epaper.vishwavani.news',
    category: 'newspapers',
    frequency: 1,
  },

  {
    name: 'scientificamerican',
    url: 'https://www.scientificamerican.com',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'crazyaboutstartups',
    url: 'https://www.crazyaboutstartups.com/',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'red-canary',
    url: 'https://redcanary.com/blog/',
    category: 'opsec',
    frequency: 7,
  },
  {
    name: 'sophos',
    url: 'https://nakedsecurity.sophos.com/',
    category: 'opsec',
    frequency: 7,
  },
  {
    name: 'underthebreach',
    url: 'https://underthebreach.medium.com/',
    category: 'opsec',
    frequency: 7,
  },
  {
    name: 'exploit-db',
    url: 'https://www.exploit-db.com/',
    category: 'opsec',
    frequency: 3,
  },
  {
    name: 'securelist',
    url: 'https://securelist.com/',
    category: 'opsec',
    frequency: 7,
  },
  {
    name: 'thehackernews',
    url: 'https://thehackernews.com/',
    category: 'opsec',
    frequency: 1,
  },
  {
    name: 'science alert',
    url: 'https://www.sciencealert.com/',
    category: 'science',
    frequency: 3,
  },
  {
    name: 'ml_thehackernews',
    url: 'https://mln.dev/top/1',
    category: 'ML/DL',
    frequency: 1,
  },
  {
    name: 'techcrunch',
    url: 'https://techcrunch.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'thenextweb',
    url: 'https://thenextweb.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'thedailywtf',
    url: 'https://thedailywtf.com/',
    category: 'thought_provoking',
    frequency: 1,
  },
  {
    name: 'digitaltrends',
    url: 'https://www.digitaltrends.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'news_ycombinator',
    url: 'https://news.ycombinator.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'lobsters',
    url: 'https://lobste.rs/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'hackerer_news',
    url: 'https://hackerer.news/',
    category: 'tech_news',
    frequency: 2,
  },
  {
    name: 'lemmy',
    url: 'https://lemmy.ml/',
    category: 'tech_news',
    frequency: 7,
  },
  {
    name: 'economist',
    url: 'https://www.economist.com/',
    category: 'financial',
    frequency: 3,
  },
  {
    name: 'bloomberg',
    url: 'https://www.bloomberg.com/',
    category: 'financial',
    frequency: 3,
  },
  {
    name: 'datacenterdynamics',
    url: 'https://www.datacenterdynamics.com/en/',
    category: 'tech_news',
    frequency: 3,
  },
  {
    name: 'lobsters',
    url: 'https://lobste.rs/',
    category: 'tech_news',
    frequency: 3,
  },
  {
    name: 'wall street journal',
    url: 'https://www.wsj.com/',
    category: 'financial',
    frequency: 3,
  },
  {
    name: 'financial times',
    url: 'https://www.ft.com/',
    category: 'financial',
    frequency: 3,
  },
  {
    name: 'economic times',
    url: 'https://economictimes.indiatimes.com/',
    category: 'financial',
    frequency: 3,
  },
  {
    name: 'mit technologyreview',
    url: 'https://www.technologyreview.com/',
    category: 'tech_news',
    frequency: 2,
  },
  {
    name: 'vocabulary',
    url: 'https://www.vocabulary.com/',
    category: 'learning',
    frequency: 1,
  },
  {
    name: 'tweetdeck.twitter',
    url: 'https://tweetdeck.twitter.com/',
    category: 'social media',
    frequency: 2,
  },
  {
    name: 'thereader.mitpress',
    url: 'https://thereader.mitpress.mit.edu/',
    category: 'general',
    frequency: 7,
  },

  {
    name: 'qz',
    url: 'https://qz.com/india/',
    category: 'general',
    frequency: 4,
  },
  {
    name: 'theverge',
    url: 'https://www.theverge.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'zdnet',
    url: 'https://www.zdnet.com/',
    category: 'tech_news',
    frequency: 1,
  },
  // {
  //   name: 'nuzzel',
  //   url: 'https://nuzzel.com/',
  //   category: 'news',
  //   frequency: 1,
  // },
  {
    name: 'wired',
    url: 'https://www.wired.com/',
    category: 'tech_news',
    frequency: 1,
  },
  {
    name: 'theguardian',
    url: 'https://www.theguardian.com/international',
    category: 'news',
    frequency: 2,
  },
  {
    name: 'bbc',
    url: 'https://bbc.com',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'cnn',
    url: 'https://cnn.com',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'ndtv',
    url: 'https://ndtv.com',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'republicworld',
    url: 'https://www.republicworld.com/',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'the hindu',
    url: 'https://epaper.thehindu.com/',
    category: 'news',
    frequency: 2,
  },
  {
    name: 'ieee spectrum',
    url: 'https://spectrum.ieee.org/',
    category: 'tech_news',
    frequency: 3,
  },
  {
    name: 'indiatoday',
    url: 'https://www.indiatoday.in/',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'wion',
    url: 'https://www.wionews.com/',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'south china morning post',
    url: 'https://www.scmp.com/asia',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'al jazeera',
    url: 'https://www.aljazeera.com/',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'arxiv-sanity',
    url: 'http://www.arxiv-sanity.com/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'arxiv',
    url: 'https://arxiv.org/',
    category: 'science',
    frequency: 2,
  },
  {
    name: 'fast.ai',
    url: 'https://www.fast.ai/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: 'washingtonpost',
    url: 'https://www.washingtonpost.com/',
    category: 'news',
    frequency: 2,
  },
  {
    name: 'nytimes',
    url: 'https://www.nytimes.com/',
    category: 'news',
    frequency: 2,
  },
  {
    name: 'thedebrief',
    url: 'https://thedebrief.org/',
    category: 'science',
    frequency: 7,
  },
  {
    name: 'github',
    url: 'https://github.com/',
    category: 'general',
    frequency: 2,
  },
  {
    name: 'thegradient',
    url: 'https://thegradient.pub',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'reddit',
    url: 'https://www.reddit.com/',
    category: 'ML/DL',
    frequency: 1,
  },
  {
    name: 'reddit',
    url: 'https://www.reddit.com/r/MachineLearning/',
    category: 'ML/DL',
    frequency: 1,
  },
  {
    name: 'discordapp',
    url: 'https://discordapp.com/channels/514337135491416065/555093365742501928',
    category: 'comm/email',
    frequency: 7,
  },
  {
    name: 'spearhead',
    url: 'https://spearhead.co/',
    category: 'general',
    frequency: 7,
  },
  {
    name: 'crunchbase',
    url: 'https://www.crunchbase.com/',
    category: 'biz',
    frequency: 3,
  },
  {
    name: 'crazyaboutstartups',
    url: 'https://crazyaboutstartups.com',
    category: 'biz',
    frequency: 3,
  },
  {
    name: 'entrackr',
    url: 'https://entrackr.com/',
    category: 'biz',
    frequency: 3,
  },
  {
    name: 'hbr',
    url: 'https://hbr.org/',
    category: 'biz',
    frequency: 7,
  },
  {
    name: 'paperswithcode',
    url: 'https://paperswithcode.com/sota',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'mix',
    url: 'https://mix.com/',
    category: 'misc',
    frequency: 7,
  },
  {
    name: 'codeforces',
    url: 'http://codeforces.com/',
    category: 'coding_competitions',
    frequency: 7,
  },
  {
    name: 'google trends',
    url: 'https://trends.google.com/',
    category: 'interesting',
    frequency: 2,
  },
  {
    name: "that's nonsense",
    url: 'https://thatsnonsense.com',
    category: 'interesting',
    frequency: 2,
  },
  {
    name: 'experiments with google',
    url: 'https://experiments.withgoogle.com/',
    category: 'interesting',
    frequency: 2,
  },
  {
    name: 'iforcedabot',
    url: 'https://iforcedabot.com/',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'deephunt',
    url: 'https://deephunt.in/',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'google codejam',
    url: 'https://codingcompetitions.withgoogle.com/codejam',
    category: 'coding_competitions',
    frequency: 7,
  },
  {
    name: 'csa.iisc.ac',
    url: 'https://www.csa.iisc.ac.in/sem-evts/seminars.php',
    category: 'important',
    frequency: 7,
  },
  {
    name: 'workflowy',
    url: 'https://workflowy.com/',
    category: 'important',
    frequency: 7,
  },
  {
    name: 'forbes',
    url: 'https://www.forbes.com',
    category: 'biz',
    frequency: 7,
  },
  {
    name: 'slashdot',
    url: 'https://slashdot.org/',
    category: 'tech_news',
    frequency: 2,
  },
  {
    name: 'buzzfeed',
    url: 'https://www.buzzfeed.com/',
    category: 'misc',
    frequency: 7,
  },
  {
    name: 'madewithml',
    url: 'https://madewithml.com/',
    category: 'ML/DL',
    frequency: 7,
  },
  {
    name: 'databricks blog',
    url: 'https://databricks.com/blog',
    category: 'work/career',
    frequency: 7,
  },
  {
    name: 'databricks engineering blog',
    url: 'https://databricks.com/blog/category/engineering',
    category: 'work/career',
    frequency: 7,
  },
  {
    name: 'azure blog',
    url: 'https://azure.microsoft.com/en-in/blog/',
    category: 'work/career',
    frequency: 7,
  },
  {
    name: 'azure announcements',
    url: 'https://azure.microsoft.com/en-in/blog/topics/announcements/',
    category: 'work/career',
    frequency: 7,
  },

  {
    name: 'hackernews best comments',
    url: 'https://news.ycombinator.com/bestcomments',
    category: 'interesting',
    frequency: 1,
  },
  {
    name: 'market business news',
    url: 'https://marketbusinessnews.com/',
    category: 'news',
    frequency: 1,
  },
  {
    name: 'panda app - news agg',
    url: 'https://app.usepanda.com/#/',
    category: 'news',
    frequency: 2,
  },
  {
    name: 'twitch',
    url: 'https://www.twitch.tv/directory',
    category: 'entertainment',
    frequency: 2,
  },
  {
    name: 'petapixel',
    url: 'https://petapixel.com/',
    category: 'ML/DL',
    frequency: 2,
  },
  {
    name: '80LV',
    url: 'https://80.lv/',
    category: 'ML/DL',
    frequency: 2,
  },
];



// WEBPACK FOOTER //
// ./src/links.js